<div>
    <button [disabled]="disabled"  [ngStyle]="{'opacity': disabled ? '.5' : '1'}" mat-button *ngIf="primaryBtn" style="background-color: #384952;color: white;border-radius: 100px;" (click)="primaryBtn.method()"><mat-icon *ngIf="primaryBtn.icon">{{primaryBtn.icon}}</mat-icon> {{primaryBtn.text}}</button>
</div>